import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Lab} from '../lab';
import {LabService} from '../lab-service.service';


@Component({
  selector: 'app-labs',
  templateUrl: './labs.component.html',
  styleUrls: ['./labs.component.css']
})
export class LabsComponent implements OnInit {

  public curLab :Lab;
  private id:number;

  constructor(public route:ActivatedRoute,public labService:LabService) {
  }

  getLab(): void {
    this.route.params.subscribe(data=>{
      console.log("Lab id"+data.id);
      this.id = data.id;
      this.curLab = this.labService.getLab(this.id);
      this.labService.setCurLab(this.curLab.id);
      console.log("Cur Lab id:"+this.curLab.id);
    });


      // .subscribe(hero => this.hero = hero);
  }

  ngOnInit() {
    this.getLab();
  }

}


